import {Component, EventEmitter, Input, OnInit, OnDestroy, Output} from '@angular/core';
import {Router} from '@angular/router';
import {UserCredentials} from '../domain/userCredentials';
import {LoginService} from '../service/login.service';

@Component({
    selector: 'operator-loggin',
    template: require('./operatorLogin.component.html')
})

export class OperatorLoginComponent implements OnInit {

    @Input() modal:any;
    @Output() close = new EventEmitter();

    private credentials:UserCredentials;

    public errorMessage:string;

    constructor(private router:Router,
                private loginService:LoginService) {
        this.init();
    }

    private init():void {
        this.credentials = new UserCredentials(null);
    }

    public ngOnInit() {
    }

    public authenticate():void {
        this.loginService.authenticate(this.credentials)
            .subscribe(
                () => {
                    if (this.modal) {
                        this.modal.hide();
                    }
                    this.goToHome();
                },
                (error) => {
                    if (error.status == '401') {
                        this.errorMessage = 'Usuario o password inválido';
                    } else {
                        this.bindError('Ocurrió un error.');
                        this.errorMessage = 'Ocurrió un error.';
                    }
                });
    }

    private goToHome():void {
        this.router.navigate(['app/home']);
    }

    private bindError(messageError:string):void {
        if (this.errorMessage == null) {
            this.errorMessage = messageError;
        } else {
            this.errorMessage = this.errorMessage.toString() + ' ' + messageError;
        }
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/login/operatorLogin.component.ts
 **/